<template>
  <popup ref="popup" :loading="popupLoading" :appendToBody="true">
    <div slot="body">
      <el-form class="dataForm" ref="form" :model="formParameter" :inline="true" label-width="120px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-table class="table" :data="parameter" stripe border height="620px">
              <el-table-column label="序号" width="50" type="index">
              </el-table-column>
              <el-table-column prop="name" width="90" label="姓名"> </el-table-column>
              <el-table-column prop="sex" width="60" label="性别"></el-table-column>
              <el-table-column prop="post" width="60" label="岗位"></el-table-column>
              <el-table-column prop="grade" width="70" label="学历"></el-table-column>
              <el-table-column prop="schoolid" label="学校">
                <template slot-scope="scope">
                  {{ scope.row.gradedate }} | {{ scope.row.schoolid }} | {{ scope.row.subject }}
                </template>
              </el-table-column>
              <el-table-column prop="jser" width="110" label="导入时间">
              </el-table-column>
              <el-table-column prop="dyer" width="100" label="归属">
                <template slot-scope="scope">
                  <div v-if="'分发电邀权限' == title">
                    <el-tag v-if="scope.row.dyer" type="danger" size="mini">属于{{ scope.row.dyer }}</el-tag>
                    <el-tag v-else type="success" size="mini">可分配</el-tag>
                  </div>
                  <div v-else>
                    <el-tag v-if="scope.row.zxer" type="danger" size="mini">属于{{ scope.row.zxer }}</el-tag>
                    <el-tag v-else type="success" size="mini">可分配</el-tag>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="分配给:" prop="dyer">
              <el-select v-model="uname" placeholder="请选择">
                <el-option v-for="item in users" :key="item.name" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" :loading="confirmLoading" @click="confirm()">提交派单</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/consu/consultation/consultation.js";
import apiuser from '@/api/system/user/user.js';

export default {
  name: "d2dy",
  components: {
    popup,
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: [],
      formParameter: {},
      ids: [],
      users: {},
      type: 1,
      ids: [],
      me: {},
      uname: "",
      rules: {},
    };
  },
  methods: {
    //打开弹框
    open(parameter, title, disabled, size) {


      this.me = this.$caches.user.get();
      // console.log("this.me",this.me)

      this.ids = parameter;

      api.list4Dispatch({ ids: this.ids }, res => {
        this.parameter = res.data
      })

      if ("分发电邀权限" == title) {

        if (this.me.role == "dy") {
          this.users = [this.me]
          this.uname = this.me.name
        } else {

          let users
          if (this.$caches.users && this.$caches.users.get()) {
            users = this.$caches.users.get();
          } else {
            //继续加载
            apiuser.listAll({}, res => {
              this.$caches.users.set(res.data);
              users = res.data
            })
          }

          this.users = users.dys;
        }
        this.type = 1;

      } else if ("分发咨询权限" == title) {

        if (this.me.role == "ad" || this.me.role == "mg" || this.me.role2 == "zxm") {
          let users
          if (this.$caches.users && this.$caches.users.get()) {
            users = this.$caches.users.get();
          } else {
            //继续加载
            apiuser.listAll({}, res => {
              this.$caches.users.set(res.data);
              users = res.data
            })

          }

          this.users = users.zxs;
        } else if (this.me.role == "zx" || this.me.role == "qd") {
          this.users = [this.me]
          this.uname = this.me.name
        }
        
        this.type = 2;

      } else if ("分发技术支持权限" == title) {
        if (this.me.role == "tr") {
          this.users = users.zxs;
        } else {
          this.users = users.trs;
        }
        this.type = 3;
      }

      this.disabled = disabled;
      this.$refs.popup.open(title, "50%");
      this.title = title
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.parameter0 = {}
      this.uname = ""
      this.ids = []
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.confirmLoading = true;
      let ids = []
      this.parameter.forEach(element => {
        ids.push(element.id)
      });

      let param = { ids: ids, uname: this.uname, type: this.type };

      api.dspConus(
        param,
        (response) => {
          this.$utils.msg.success(response.msg);
          this.confirmLoading = false;
          this.close();
          this.$emit("flush");
        },
        (response) => {
          this.$utils.msg.warning(response.msg);
          this.confirmLoading = false;
        }
      );
    },
    init() {
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();
      this.popupLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
